import { AttemptResult, AttemptStatus } from "api/resources/assessments/types"

export function getTagStyle(
  {
    result,
    status,
  }: {
    status: AttemptStatus | null | undefined
    result?: AttemptResult | null
    endTime?: string
  },
  options?: {
    showNeutralResultTags?: boolean
  }
): {
  label: "Passed" | "Failed" | "Completed" | "Missed" | "Continue" | "Available"
  color?:
    | "onSurface"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "critical"
    | "one"
    | "two"
    | "three"
    | "four"
    | null
} | null {
  const neutralTag = { label: "Completed", color: "primary" } as const

  if (status === AttemptStatus.MISSED) {
    return { label: "Missed", color: "critical" }
  }
  if (result === AttemptResult.PASS) {
    if (options?.showNeutralResultTags) return neutralTag
    return { label: "Passed", color: "success" }
  }
  if (result === AttemptResult.FAIL) {
    if (options?.showNeutralResultTags) return neutralTag
    return { label: "Failed", color: "critical" }
  }
  if (status === AttemptStatus.COMPLETED) {
    return neutralTag
  }

  if (status === AttemptStatus.IN_PROGRESS) {
    return { label: "Continue", color: "primary" }
  }

  return { label: "Available", color: "primary" }
}
